import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddRoofTypeModal from "./components/AddRoofTypeModal";
import RoofTypeTable from "./components/RoofTypeTable";
import {
  selectRoofTypeList,
  selectRoofTypeLoading,
  selectRoofTypeMeta,
} from "./redux/selector";
import roofTypeSaga from "./redux/saga";
import { roofTypeActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const RoofType = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: roofTypeSaga,
  });

  const rows = useSelector(selectRoofTypeList);
  const loading = useSelector(selectRoofTypeLoading);
  const meta = useSelector(selectRoofTypeMeta);

  useEffect(() => {
    dispatch(roofTypeActions.getRoofTypeList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(roofTypeActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.ROOF_TYPE")} iconPosition="end" />
          <Box dir="ltr">
            <AddButton
              label={t("ROOF_TYPE.ACTIONS.ADD")}
              onClick={() => dispatch(roofTypeActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <RoofTypeTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddRoofTypeModal />
    </Box>
  );
};

export default RoofType;
